import { dateFormat } from 'design-system';
import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { Customer, LegalEntity } from 'data-layer-cr/dist/models';

// models
import { NATURAL_PERSON } from 'data-layer-cr/dist/constants/customerTypes';
import { CustomerType } from '../../../../../models/helperTypes/CustomerItem';

// Methods
import genderString from '../../../../../functions/genderString';

// sub components
import CatalogItem from '../../../../../models/helperTypes/CatalogItem';
import PricingProfileResponse from '../../../../../models/responseTypes/PricingProfileResponse';
import CardQuotation from '../CardQuotation';

const { dateFromServerString } = dateFormat;

type Props = {
  customerType: CustomerType;
  customer: Customer;
  legalEntity: LegalEntity;
  currentProfile?: PricingProfileResponse;
};

const packageName: React.ReactNode = (
  <Grid container style={{ paddingBottom: '7px' }}>
    <img
      src="/svg/profile_icon_color_blue.svg"
      alt="profile icon"
      style={{ marginRight: 11 }}
    />
    <Typography style={{ fontSize: '19px', fontWeight: 900 }}>
      Datos del contratante
    </Typography>
  </Grid>
);

function renderNaturalCustomer(
  customer: Customer,
  currentProfile?: PricingProfileResponse,
): JSX.Element {
  const defaultDataListForIndividual: CatalogItem[] = [
    {
      Value: 'Fecha de nacimiento',
      Text: dateFromServerString(customer.birthday),
    },
    { Value: 'Género', Text: genderString(customer.gender) },
    { Value: 'Celular', Text: `+506 ${customer.phone}` },
    { Value: 'Email', Text: customer.email },
  ];
  const defaultDataListForCollective: CatalogItem[] = [
    { Value: 'Celular', Text: `+506 ${customer.phone}` },
    { Value: 'Email', Text: customer.email },
  ];

  return (
    <CardQuotation
      title={packageName}
      subTitle={`${customer.firstName} ${customer.lastName}`}
      defaultDataList={
        currentProfile && currentProfile.type === 'colectiva'
          ? defaultDataListForCollective
          : defaultDataListForIndividual
      }
    />
  );
}

function renderLegalCustomer(legalEntity: LegalEntity): JSX.Element {
  return (
    <CardQuotation
      title={packageName}
      subTitle={`${legalEntity.name}`}
      defaultDataList={[
        { Value: 'Celular o teléfono', Text: `+506 ${legalEntity.phone}` },
        { Value: 'Email', Text: legalEntity.email },
      ]}
    />
  );
}

/**
 * CustomerDetailsCard displays information regarding both Natural Person and Legal Person customers
 */
const CustomerDetailsCard = ({
  customerType,
  customer,
  legalEntity,
  currentProfile,
}: Props): JSX.Element => {
  return customerType === NATURAL_PERSON
    ? renderNaturalCustomer(customer, currentProfile)
    : renderLegalCustomer(legalEntity);
};

export default CustomerDetailsCard;
